module.exports = __webpack_public_path__ + "214308101b12d4b18418c1c8660d6d63.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/moderne.svg
// module id = 15
// module chunks = 0